import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { PaymentType } from 'shared/ui/payment-type'
import { PopupContent } from 'shared/ui/poup-content'

import { MplusNotAllowCard } from '../components/mplus-not-allow-card'

import s from './styles.module.scss'

export const MplusNotAllow = () => {
  const { t } = useTranslation()

  const { openDialog, closeDialog } = useDialogBottomSheet()

  const onShowPopUp = () => {
    openDialog({
      isDialog: false,
      child: (
        <PopupContent
          padding={[6]}
          button={'Ок'}
          onClick={closeDialog}
          title={t('mplus.connect_mplus')}
          content={
            <div className={clsx(s.contentAllow, 'regular-14')}>
              {t('mplus.mplus_title_not_allow')}
              <ul className={s.list}>
                <li>{t('mplus.mplus_title_not_one')}</li>
                <li>{t('mplus.mplus_title_not_two')}</li>
                <li>{t('mplus.mplus_title_not_three')}</li>
              </ul>
            </div>
          }
        />
      ),
    })
  }

  return (
    <div className={s.container}>
      <PaymentType
        isActive
        icon={AllIcons.CASH}
        title={t('mplus.pay_current')}
        subTitle={t('mplus.with_trans_mbank')}
      />

      <MplusNotAllowCard onShowPopUp={onShowPopUp} />
    </div>
  )
}
